import { type VariantProps, cva } from 'class-variance-authority';
import type * as React from 'react';
import { cn } from '../../lib/utils';

const badgeVariants = cva(
  'inline-flex items-center justify-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-medium transition-colors',
  {
    variants: {
      variant: {
        default: 'bg-gray-100 text-gray-700',
        primary: 'bg-brand-50 text-brand-600',
        success: 'bg-success-50 text-success-600',
        error: 'bg-error-50 text-error-600',
        warning: 'bg-warning-50 text-warning-600',
        outline: 'border border-gray-300 text-gray-700',
        'solid-primary': 'bg-brand-500 text-white',
        'solid-success': 'bg-success-500 text-white',
        'solid-error': 'bg-error-500 text-white',
        'solid-warning': 'bg-warning-500 text-white',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}
